import { z } from 'zod';

/**
 * Bus events emitted by the identity module's auth routes. Per ADR 0015
 * (auditability), these are the publisher contract; persistence into
 * `_kernel.audit_event` lands with IMM-56's audit subscriber. Payload
 * shapes pin: actor (always WorkOS user when known), the network
 * fingerprint (pseudonymised per ADR 0015 §V1 exception), and the
 * provider for sign-in events. PII is intentionally absent — email
 * lives in the identity DB, the audit row carries only references.
 */

const NetworkContextSchema = z.object({
  /**
   * IPv4 truncated to /24 or IPv6 truncated to /48 at the publishing
   * site, per ADR 0015 §V1 exception for `identity.auth.*`.
   */
  ipPrefix: z.string().min(1),
  userAgent: z.string().min(1).optional(),
});

export const SignInSucceededPayloadSchema = z.object({
  userId: z.string().min(1),
  provider: z.enum(['authkit', 'google', 'microsoft', 'sandbox', 'sandbox-agent']),
  network: NetworkContextSchema,
});

export const SignInFailedPayloadSchema = z.object({
  /** Present when the failure happened after the code exchange identified a user. */
  userId: z.string().min(1).optional(),
  provider: z.enum(['authkit', 'google', 'microsoft', 'sandbox', 'sandbox-agent']),
  /** Stable failure code, e.g. `code-exchange-failed`, `state-mismatch`. */
  reason: z.string().min(1),
  network: NetworkContextSchema,
});

export const SignOutPayloadSchema = z.object({
  userId: z.string().min(1),
  network: NetworkContextSchema,
});
